import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TmsWebBaseEditService } from 'tms-web-shared';
import {
  FinishingProgress,
  IntoStockProgress,
  MendingProgress,
  PerchingProgress,
  PieceProgress,
  PieceProgressList,
  WarpingProgress,
  WeavingProgress,
} from '../../../models';

@Injectable({
  providedIn: 'root',
})
// The office side of piece progress. The scanner has its own service against the
// TmsScanner area - never call these endpoints from the scanner (403).
//
// Extends the edit service purely for its search(), which drives the progress list;
// there is no edit/save/delete of a progress row as a whole - each STAGE is saved
// through its own endpoint below.
export class PieceProgressService extends TmsWebBaseEditService<PieceProgressList, PieceProgress> {
  constructor() {
    super('PieceProgress', $localize`Piece Progress`);
  }

  getForPiece(pieceId: string): Observable<PieceProgress> {
    return this.httpService.get<PieceProgress>(`${this.apiUrl}/Piece/${pieceId}`);
  }

  saveWarping(model: WarpingProgress): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/Warping`, model);
  }

  saveWeaving(model: WeavingProgress): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/Weaving`, model);
  }

  saveMending(model: MendingProgress): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/Mending`, model);
  }

  savePerching(model: PerchingProgress): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/Perching`, model);
  }

  saveFinishing(model: FinishingProgress): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/Finishing`, model);
  }

  // Recording this stage is also what books the stock (WS5) - see the API service.
  saveIntoStock(model: IntoStockProgress): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/IntoStock`, model);
  }
}
